import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export const deleteSubCategory = async (id: string) => {
  try {
    const response = await axiosInstance.delete(
      `${config.apiUrl}/sub-categories/${id}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Error deleting sub category"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
};
